import { Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { CheckoutGuard } from "./guards/checkout.guard";
import { ProfileGuard } from "./guards/profile.guard";
import { RootGuard } from "./guards/root.guard";

export const routes: Routes = [
  {
    path: "",
    loadComponent: () => import("./pages/home/home.component").then((m) => m.HomeComponent),
    canActivate: [RootGuard],
  },
  {
    path: "assine",
    loadComponent: () => import("./pages/paywall/paywall.component").then((m) => m.PaywallComponent),
  },
  {
    path: "assine-empresa",
    loadComponent: () =>
      import("./pages/paywall/paywall-company/paywall-company.component").then((m) => m.PaywallCompanyComponent),
  },
  // Auth routes - URLs em português
  {
    path: "entrar",
    title: "Entrar | Diário do Nordeste",
    loadComponent: () => import("./pages/auth/login/login.component").then((m) => m.LoginComponent),
  },
  {
    path: "cadastro",
    title: "Crie sua conta | Diário do Nordeste",
    loadComponent: () => import("./pages/auth/signup/signup.component").then((m) => m.SignupComponent),
  },
  {
    path: "esqueci-minha-senha",
    title: "Recuperar senha | Diário do Nordeste",
    loadComponent: () =>
      import("./pages/auth/forgot-password/forgot-password.component").then((m) => m.ForgotPasswordComponent),
  },
  {
    path: "criar-senha",
    title: "Crie sua nova senha | Diário do Nordeste",
    loadComponent: () =>
      import("./pages/auth/create-password/create-password.component").then((m) => m.CreatePasswordComponent),
  },
  {
    path: "login-sem-senha",
    title: "Login sem senha | Diário do Nordeste",
    loadComponent: () =>
      import("./pages/auth/login-without-password/login-without-password.component").then(
        (m) => m.LoginWithoutPasswordComponent,
      ),
  },
  {
    path: "confirmacao",
    title: "Código de confirmação | Diário do Nordeste",
    loadComponent: () =>
      import("./pages/auth/confirmation/confirmation.component").then((m) => m.ConfirmationComponent),
  },
  // Minha Conta (profile) routes
  {
    path: "minha-conta",
    title: "Minha conta | Diário do Nordeste",
    canActivate: [AuthGuard, ProfileGuard],
    children: [
      {
        path: "",
        title: "Minha conta | Diário do Nordeste",
        loadComponent: () => import("./pages/profile/profile.component").then((m) => m.ProfileComponent),
      },
      {
        path: "dados-pessoais",
        title: "Dados pessoais - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/personal-data/personal-data.component").then((m) => m.PersonalDataComponent),
      },
      {
        path: "gerenciar-acessos",
        title: "Gerenciar acessos - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/access-management/access-management.component").then(
            (m) => m.AccessManagementComponent,
          ),
      },
      {
        path: "gerenciar-assinatura",
        title: "Gerenciar assinatura - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/subscription-management/subscription-management.component").then(
            (m) => m.SubscriptionManagementComponent,
          ),
      },
      {
        path: "cancelar-assinatura",
        title: "Cancelar assinatura - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/cancel-subscription/cancel-subscription.component").then(
            (m) => m.CancelSubscriptionComponent,
          ),
      },
      {
        path: "novo-membro",
        title: "Adicionar membro - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/access-new-member/access-new-member.component").then(
            (m) => m.AccessNewMemberComponent,
          ),
      },
      {
        path: "editar-membro/:id",
        title: "Editar membro - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/access-edit-member/access-edit-member.component").then(
            (m) => m.AccessEditMemberComponent,
          ),
      },
      {
        path: "editar-nome",
        title: "Editar nome - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/edit-name/edit-name.component").then((m) => m.EditNameComponent),
      },
      {
        path: "editar-email",
        title: "Editar e-mail - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/edit-email/edit-email.component").then((m) => m.EditEmailComponent),
      },
      {
        path: "editar-senha",
        title: "Editar senha - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/edit-password/edit-password.component").then((m) => m.EditPasswordComponent),
      },
      {
        path: "editar-telefone",
        title: "Editar telefone - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/edit-phone/edit-phone.component").then((m) => m.EditPhoneComponent),
      },
      {
        path: "endereco",
        title: "Endereço - Minha conta | Diario do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/address-edit/address-edit.component").then((m) => m.AddressEditComponent),
      },
      {
        path: "excluir-conta",
        title: "Excluir conta - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/remove-account/remove-account.component").then((m) => m.RemoveAccountComponent),
      },
      {
        path: "codigo-confirmacao",
        title: "Código de confirmação - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/confirmation-code/confirmation-code.component").then(
            (m) => m.ConfirmationCodeComponent,
          ),
      },
      {
        path: "pagamentos",
        title: "Pagamentos - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/payment-history/payment-history.component").then(
            (m) => m.PaymentHistoryComponent,
          ),
      },
      {
        path: "ajuda-e-suporte",
        title: "Ajuda e Suporte - Minha conta | Diário do Nordeste",
        loadComponent: () => import("./pages/profile/pages/support/support.component").then((m) => m.SupportComponent),
      },
      {
        path: "ajuda-e-suporte/:id",
        title: "Ajuda e Suporte - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/support-details/support-details.component").then(
            (m) => m.SupportDetailsComponent,
          ),
      },
      {
        path: "atualizar-pagamento",
        title: "Atualizar pagamento - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/payment-update/payment-update.component").then((m) => m.PaymentUpdateComponent),
      },
      {
        path: "novo-cartao",
        title: "Adicionar cartão - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/payment-card-create/payment-card-create.component").then(
            (m) => m.PaymentCardCreateComponent,
          ),
      },
      {
        path: "meus-beneficios",
        title: "Meus benefícios - Minha conta | Diário do Nordeste",
        loadComponent: () => import("./pages/profile/pages/my-benefits/my-benefits.component").then((m) => m.MyBenefitsComponent),
      },
      {
        path: "alterar-plano",
        title: "Alterar plano - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/change-plan/change-plan.component").then((m) => m.ChangePlanComponent),
      },
      {
        path: "revisar-assinatura",
        title: "Revisar assinatura - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/review-update-subscription/review-update-subscription.component").then(
            (m) => m.ReviewUpdateSubscriptionComponent,
          ),
      },
      {
        path: "upgrade-checkout",
        title: "Dados para Upgrade - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/upgrade-register/upgrade-register.component").then(
            (m) => m.UpgradeRegisterComponent,
          ),
      },
      {
        path: "upgrade-revisar",
        title: "Confirmar Upgrade - Minha conta | Diário do Nordeste",
        loadComponent: () =>
          import("./pages/profile/pages/upgrade-review/upgrade-review.component").then(
            (m) => m.UpgradeReviewComponent,
          ),
      },
      {
        path: "upgrade-pix",
        title: "Pagamento PIX - Minha conta | Diário do Nordeste",
        loadComponent: () => import("./pages/checkout/pix/pix.component").then((m) => m.PixComponent),
      },
    ],
  },
  // Checkout routes
  {
    path: "checkout",
    canActivate: [AuthGuard, CheckoutGuard],
    children: [
      {
        path: "",
        redirectTo: "dados-pessoais",
        pathMatch: "full",
      },
      {
        path: "dados-pessoais",
        title: "Assinatura | Diário do Nordeste",
        loadComponent: () => import("./pages/checkout/register/register.component").then((m) => m.RegisterComponent),
      },
      {
        path: "forma-de-pagamento",
        title: "Pagamento | Diário do Nordeste",
        loadComponent: () => import("./pages/checkout/payment/payment.component").then((m) => m.PaymentComponent),
      },
      {
        path: "resumo",
        title: "Revise sua assinatura | Diário do Nordeste",
        loadComponent: () => import("./pages/checkout/summary/summary.component").then((m) => m.SummaryComponent),
      },
      {
        path: "pix",
        title: "Pagamento PIX | Diário do Nordeste",
        loadComponent: () => import("./pages/checkout/pix/pix.component").then((m) => m.PixComponent),
      },
      {
        path: "sucesso",
        title: "Assinatura concluída | Diário do Nordeste",
        loadComponent: () => import("./pages/checkout/success/success.component").then((m) => m.SuccessComponent),
      },
    ],
  },
  // Fallback: redireciona qualquer rota não encontrada para /assine
  {
    path: "**",
    redirectTo: "assine",
  },
];
